import { TDate } from '../dates.types';
import { TFilterSelected } from '../filter.types';
import { TPaginationInfo } from '../input-app/fabric-inspection/api.types';
import { TM8MachineId } from './factory.types';
import { TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA } from './line-setup-API.types';

export const LINE_SETUP_TICKET_STATUSES = ['UPCOMING', 'IN_PROGRESS', 'OVERDUE', 'COMPLETED'] as const;
export type TLineSetupTicketStatus = (typeof LINE_SETUP_TICKET_STATUSES)[number];
export type TLineSetupTicketId = string;
export type TLineSetupTicketSubtaskType = 'ASSIGN_MACHINE' | 'REMOVE_MACHINE' | 'REPLACE_MACHINE';
export type TLineSetupTicketSubtaskStatus = 'PENDING' | 'COMPLETED';
export type TLineSetupTicket = {
  ticketId: TLineSetupTicketId;
  location: {
    line: string;
  };
  startTimeOpt?: number;
  endTimeOpt?: number;
  dueDate: TDate;
  assignedMechanics: TEmployeeBasicDetails[];
  locationId: string;
};

export type TLineSetupTicketSubtask = {
  id: string;
  workstationId: number;
  startTime: number;
  endTime?: number;
  assignedMechanic: { name: string; id: string };
  workstationName: string;
  subTaskType: TLineSetupTicketSubtaskType;
  status: TLineSetupTicketSubtaskStatus;
  currentSerialNumberOpt?: string;
  currentMachineIdOpt?: TM8MachineId;
};

type TEmployeeBasicDetails = {
  employeeId: string;
  employeeName: string;
  employeeRole: string;
};

export type TREQUEST_LINE_SETUP_TICKET_LISTING = {
  bucket: TLineSetupTicketStatus;
  selectedFilters: TFilterSelected[];
  page: number;
  itemsPerPage: number;
};
export type TRESPONSE_LINE_SETUP_TICKET_LISTING = {
  tickets: TLineSetupTicket[];
  paginationInfo: TPaginationInfo;
  filters: TFilterSelected[];
};

export type TRESPONSE_LINE_SETUP_TICKET_DETAILS = {
  workstationGroups: {
    groupId: string;
    workstations: {
      nameRep: string;
      machineType: string;
      machineCategory: string;
      subCategoryOpt?: string;
    }[];
  }[];
};

export type TREQUEST_LINE_SETUP_TICKET_DELETE = {
  ticketIds: TLineSetupTicketId[];
};

export type TREQUEST_LINE_SETUP_TICKET_UPDATE_MECHANIC = {
  ticketId: TLineSetupTicketId;
  assignedMechanics: string[];
};

export type TREQUEST_LINE_SETUP_TICKET_UPDATE = {
  lineSetupTicketId: TLineSetupTicketId;
  updatedStatus: TLineSetupTicketStatus;
};

export type TREQUEST_LINE_SETUP_TICKET_SUBTASK_CREATE = {
  lineSetupTicketId: TLineSetupTicketId;
  workstationId: number;
  subTaskType: TLineSetupTicketSubtaskType;
};

export type TREQUEST_LINE_SETUP_TICKET_SUBTASK_DELETE = { subTaskIds: string[] };

export type TREQUEST_LINE_SETUP_TICKET_SUBTASK_LIST = { lineSetupTicketId: TLineSetupTicketId };
export type TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST = { subTasks: TLineSetupTicketSubtask[] };

export type TRESPONSE_GET_LINE_SETUP_TICKET_CURRENT_SETUP = TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA;

export type TRESPONSE_GET_ALL_ASSIGNED_MECHANICS_FOR_LOCATION = { assignedMechanicDetailList: TEmployeeBasicDetails[] };
